<h2 class="title">{{ '+VOUCHERS.GENERATE_NEW_VOUCHER' | translate }}</h2>
<vi-text class="description">{{
  '+VOUCHERS.GENERATE_NEW_VOUCHER_DESCRIPTION' | translate
}}</vi-text>
<div class="grid">
  <!-- VOUCHER TYPE -->
  <mat-form-field class="voucher-type-input" mat-select-height-large>
    <mat-label>{{ '+VOUCHERS.SELECT_VOUCHER_TYPE' | translate }}</mat-label>
    <mat-select [formControl]="formGroup.controls.voucherForm" fieldTextContentTooltip>
      <mat-select-trigger>
        <span>
          {{ formGroup.controls.voucherForm?.value?.displayKey | translate }}
        </span>
      </mat-select-trigger>
      <mat-option *ngFor="let option of voucherOptions" [value]="option" fieldTextContentTooltip>{{
        option.displayKey | translate
      }}</mat-option>
    </mat-select>
  </mat-form-field>

  <!-- OPTIONAL CUSTOMER NUMBER -->
  <mat-form-field mat-input-height-large-label class="company-number-input">
    <mat-label>{{ '+VOUCHERS.CUSTOMER_NUMBER' | translate }}</mat-label>
    <input
      matInput
      [errorStateMatcher]="matcher"
      [formControl]="formGroup.controls.customerNumber"
      fieldTextContentTooltip
    />
  </mat-form-field>

  <!-- GENERATE BTN -->
  <button
    disabled
    gtm="onSelect"
    gtmAction="Generate Voucher"
    gtmCategory="voucher"
    mat-raised-button
    color="primary"
    (click)="generateCode()"
    [disabled]="!formGroup.valid || (vouchersStore.isGeneratingVoucher$ | async)"
  >
    <ng-container *ngIf="!(vouchersStore.isGeneratingVoucher$ | async); else loading">{{
      '+VOUCHERS.GENERATE_BTN' | translate
    }}</ng-container>
    <ng-template #loading><mat-icon class="spin">autorenew</mat-icon></ng-template>
  </button>
</div>

<ng-container *ngIf="vouchersStore.getAttemptedToGenerateVoucher$ | async">
  <ng-container *ngIf="vouchersStore.voucherGeneratedSuccesfully$ | async as success">
    <app-voucher-result-box [success]="success">
      <ng-container content *ngIf="success && vouchersStore.voucher$ | async as voucher">
        <span
          [innerHtml]="
            '+VOUCHERS.GENERATE_SUCCESS'
              | translate
              | propertyWithin: getVoucherPropertyWithinOptions()
          "
        >
        </span>
        <input class="voucher-code-input" type="text" [value]="voucher" fieldTextContentTooltip />
        <span class="voucher-code">{{ voucher }}</span>
        <span class="copy-to-clipboard" (click)="copyVoucherToClipboard()">{{
          copyToClipboardStatus
        }}</span>
      </ng-container>

      <ng-container content *ngIf="!success">
        <span>{{ '+VOUCHERS.GENERATE_ERROR' | translate }}</span>
      </ng-container>
    </app-voucher-result-box>
  </ng-container>
</ng-container>
